module.exports = __webpack_public_path__ + "media/talk2.35356b2a.mp4";